module.exports = __webpack_public_path__ + "static/media/aztecross-logo.da43902e.png";